import { render, staticRenderFns } from "./OldVisaDetail.vue?vue&type=template&id=37cbd4f9&"
import script from "./OldVisaDetail.vue?vue&type=script&lang=js&"
export * from "./OldVisaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports